import { render } from "./B2bTableOcrDocuments.vue?vue&type=template&id=7c8cabcc&scoped=true&lang=pug"
import script from "./B2bTableOcrDocuments.vue?vue&type=script&lang=js"
export * from "./B2bTableOcrDocuments.vue?vue&type=script&lang=js"

import "./B2bTableOcrDocuments.vue?vue&type=style&index=0&id=7c8cabcc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8cabcc"]])

export default __exports__